import { styled } from "@mui/material";

const INDENT_WIDTH = 1;

export const StyledCollapsibleSection = styled("div")<{
  $nestingLevel?: number;
}>`
  position: relative;
  /* Ensure container takes full width of menu */
  width: 100%;
  /* Ensure each section can be scrolled to fully */
  padding-bottom: 1px;

  ${({ theme, $nestingLevel }) =>
    $nestingLevel &&
    `
      .searchable-entity-dropdown-collapsible-section {
        padding-left: calc(${INDENT_WIDTH * ($nestingLevel + 1)}rem);
      }

      .searchable-entity-dropdown-item,
      .searchable-entity-dropdown-date-field {
        padding-left: calc(
          ${theme.wsc.spacing[1]} + ${INDENT_WIDTH * ($nestingLevel + 1)}rem
        );
      }
  `}
`;

export const StyledCollapsibleSectionHeader = styled("div")<{
  $isDisabled: boolean;
}>`
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.wsc.spacing[1]};
  cursor: ${({ $isDisabled }) => ($isDisabled ? "not-allowed" : "pointer")};
  background-color: ${({ theme }) => theme.wsc.palette.neutral[700]};
  &:hover {
    background-color: ${({ theme }) => theme.wsc.palette.neutral[600]};
  }
`;

export const StyledContent = styled("div")`
  display: flex;
  flex-direction: column;
  .searchable-entity-dropdown-date-field:first-of-type {
    padding-top: ${({ theme }) => theme.wsc.spacing[1]};
  }
  padding-bottom: ${({ theme }) => theme.wsc.spacing[0]};
`;

export const StyledTitle = styled("div")`
  ${({ theme }) => theme.wsc.typography.body1};
  color: ${({ theme }) => theme.wsc.palette.neutral[100]};
  display: flex;
  align-items: center;
  flex: 1;
  overflow: hidden;

  & > :first-child {
    margin-right: ${({ theme }) => theme.wsc.spacing[0]};
  }
`;
